const normalizeBaseUrl = (value = '') => String(value || '').trim().replace(/\/$/, '');

const resolveBackendOrigin = () => {
  const configured = normalizeBaseUrl(process.env.REACT_APP_BACKEND_URL || '');
  const isPlaceholder = ['undefined', 'null'].includes(configured.toLowerCase());
  if (configured && !isPlaceholder) {
    try {
      return new URL(configured).origin;
    } catch {
      // Fall back to the runtime host when the configured URL is malformed.
    }
  }

  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }

  return '';
};

export const buildToolGoUrl = (tool = {}) => {
  const safeSlug = String(tool?.slug || tool?.tool_slug || '').trim();
  if (!safeSlug) return '#';
  return `/go/${encodeURIComponent(safeSlug)}`;
};

export const buildBackendGoRedirectUrl = (slug = '') => {
  const safeSlug = String(slug || '').trim();
  if (!safeSlug) return '#';

  const backendOrigin = resolveBackendOrigin();
  if (!backendOrigin) return '#';

  return `${backendOrigin}/api/go/${encodeURIComponent(safeSlug)}`;
};
